var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lazy-image",style:({'--ar': _vm.ar})},[_c('img',{attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }